import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router";
import EjariPageTitle from "../../../component/EjariPageTitle";
import ProcessMarker from "../../../component/Contract/ProcessMarker";
import { ManagementContractContext } from "@eres/ejari-core/contexts/ManagementContractContext";
import Properties from "../../../component/ManagementContract/Properties";
import ContractDetails from "../../../component/ManagementContract/ContractDetails";
import PaymentPlan from "../../../component/ManagementContract/PaymentPlan";
import Responsibilities from "../../../component/ManagementContract/Responsibilities";
import TermsConditions from "../../../component/ManagementContract/TermsConditions";
import Documents from "../../../component/ManagementContract/Documents";
import PropertySelection from "../../../component/ManagementContract/PropertySelection";
import { TenancyContactAction } from "@eres/ejari-core/constants";

interface Props extends RoutedViewProps {

}

class NewManagementContract extends Component<Props> {
	static contextType = ManagementContractContext;
	context!: React.ContextType<typeof ManagementContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		const pp = this.props.match.url;
		const title = this.context.action === TenancyContactAction.NEW_CONTRACT ? Strings.create_management_contract : Strings.renew_management_contract;
		return <PageContent
			title={ title }
			hideQLinks={ true }>
			<EjariPageTitle title={ title }/>
			<div className={ "management-contract" }>
				<Switch>
					<Route
						path={ pp + "/start" }
						render={ ( props: RouteComponentProps<any> ) => {
							return <ProcessMarker
								{ ...props }
								to={ pp + "/properties" }
								done={ pp + "/success" }
							/>;
						} }/>
					<Route path={ pp + "/properties/add" } component={ PropertySelection }/>
					<Route path={ pp + "/properties" } component={ Properties }/>
					<Route path={ pp + "/contract" } component={ ContractDetails }/>
					<Route path={ pp + "/payment" } component={ PaymentPlan }/>
					<Route path={ pp + "/responsibilities" } component={ Responsibilities }/>
					<Route path={ pp + "/terms" } component={ TermsConditions }/>
					<Route path={ pp + "/documents" } component={ Documents }/>
					<Route
						path={ [ pp ] } exact={ true } render={ ( _props: RouteComponentProps<any> ) => {
						return <Redirect to={ pp + "/start" }/>;
					} }>
					</Route>
				</Switch>
			</div>
		</PageContent>;
	}
}

export default NewManagementContract;
